module.exports = __webpack_public_path__ + "31c7181753243b458fa89f38d9d5cca0.svg";